App.controller('ZochHealthPzuwAddCtrl', ['$scope', '$rootScope', '$sce', '$state', '$mdDialog', 'Config', '$stateParams', '$filter', 'moment', 'packageService', 'branchService', 'zochaWorkersService', 'zochaPzuwHealthInsuranceService', 'popUpService', function ($scope, $rootScope, $sce, $state, $mdDialog, Config, $stateParams, $filter, moment, packageService, branchService, zochaWorkersService, zochaPzuwHealthInsuranceService, popUpService) {

    $scope.stateParams = $stateParams;

    $scope.ref = {};

    $scope.data = {
        originalCopyEntered: true
    };
    $scope.data.user = $scope.stateParams.user;

    /**
     * Model for pesel input in readByPeselForm;
     * @type {string}
     */
    $scope.pesel = '';

    $scope.page = 'zoch_healthInsurance';
    $scope.$emit('page', $scope.page);

    $scope.withRehabilitation = false;
    $scope.changeRehabilitationStatus = function () {
        $scope.withRehabilitation = !$scope.withRehabilitation;
        if ($scope.withRehabilitation) {
            $scope.setRehabilitationValues();
        } else {
            $scope.resetRehabilitationValues();
        }
    };

    if ($scope.data.user) {
        $scope.step = 'Wprowadź deklaracje (' + $scope.data.user.person.firstName + ' ' + $scope.data.user.person.lastName + ')';
    } else {
        $scope.step = 'Wprowadź deklaracje';
    }
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.zoch.healthPzuw.list';
    $scope.$emit('link', $scope.link);

    $scope.nationality = 'POLISH';

    // @TODO <HEALTH2019>
    $scope.packages = [];
    $scope.variants = [];
    $scope.branch = [];

    $scope.variantId = null;
    $scope.packageId = null;

    packageService.dataHealthGroupedPackageLists().then(function (data) {
        if (data.status === 200) {
            $scope.variants = data.data.group;

            var currentVariant = $scope.variants[0];
            $scope.variantId = currentVariant.name;
            $scope.chooseVariant();
        }
    });

    $scope.partner_block = true;
    $scope.children_block = true;

    function updateInsuredPersons() {
        var isPartnerAdded = !!Object.keys($scope.data.partner || {}).length;
        if ($scope.data.children.length) {
            if ($scope.package.children) {
                $scope.data.children.splice($scope.package.children);
                $scope.children_length = $scope.data.children.length;

                if ($scope.package.partner) {
                    if (isPartnerAdded) {
                        $scope.partner_length = 1;
                    } else {
                        $scope.data.partner = {};
                        $scope.partner_length = 0;
                    }
                }
            } else {
                if ($scope.package.partner) {
                    if (isPartnerAdded) {
                        $scope.data.children = [];
                        $scope.children_length = 0;
                        $scope.partner_length = 1;
                    } else {
                        $scope.data.children.splice(1);
                        $scope.children_length = $scope.data.children.length;
                        $scope.partner_length = 0;
                    }
                } else {
                    $scope.data.partner = {};
                    $scope.partner_length = 0;
                    $scope.data.children = [];
                    $scope.children_length = 0;
                }
            }
        } else if (isPartnerAdded) {
            if ($scope.package.partner) {
                $scope.partner_length = 1;
            } else {
                $scope.data.partner = {};
                $scope.partner_length = 0;
            }
        } else {
            $scope.partner_length = 0;
            $scope.children_length = 0;
        }

        isPartnerAdded = !!Object.keys($scope.data.partner || {}).length;

        var partner_block = true;
        var children_block;
        if ($scope.package && $scope.package.children) {
            children_block = $scope.data.children.length >= $scope.package.children;

            if ($scope.package.partner) {
                partner_block = isPartnerAdded;
            } else {
                partner_block = true;
            }
        } else {
            if ($scope.package && $scope.package.partner) {
                if (isPartnerAdded) {
                    partner_block = true;
                    children_block = true;
                } else {
                    if ($scope.data.children.length) {
                        partner_block = true;
                        children_block = true;
                    } else {
                        partner_block = false;
                        children_block = false;
                    }
                }
            } else {
                children_block = true;
            }
        }

        $scope.partner_block = partner_block;
        $scope.children_block = children_block;
    }

    $scope.choosePackage = function () {
        angular.forEach($scope.packages, function (value) {
            if (value.id === $scope.packageId) {
                $scope.package = value;
                $scope.data.benefit = $scope.package;
                if ($scope.package.variant === 'PARTNER' || $scope.package.variant === 'FAMILY') {
                    $scope.seniorLimit = 4;
                } else {
                    $scope.data.seniors = $scope.data.seniors.slice(0, 2);
                }
            }
        });

        updateInsuredPersons();
    };

    $scope.setRehabilitationValues = function () {
        for (var a = 0; a < $scope.packages.length; a++) {
            $scope.packages[a].name += ' + Rehabilitacja';
            $scope.packages[a].summaryPrice += $scope.packages[a].rehabilitationPrice;
        }
    };
    $scope.resetRehabilitationValues = function () {
        for (var a = 0; a < $scope.packages.length; a++) {
            $scope.packages[a].name = $scope.packages[a].name.replace(' + Rehabilitacja', '');
            $scope.packages[a].summaryPrice -= $scope.packages[a].rehabilitationPrice;
        }
    };

    $scope.chooseVariant = function () {
        if ($scope.withRehabilitation) {
            $scope.resetRehabilitationValues();
        }
        angular.forEach($scope.variants, function (value) {
            if (value.name === $scope.variantId) {
                var packages = value.options;
                $scope.packages = packages;

                if ($scope.package) {
                    var sameTypePackage;
                    angular.forEach(packages, function (pkg) {
                        if (pkg.type === $scope.package.type) {
                            sameTypePackage = pkg;
                        }
                    });

                    if (sameTypePackage && sameTypePackage.disabled !== true) {
                            $scope.packageId = sameTypePackage.id;
                    } else {
                        $scope.packageId = _.find(packages, p => p.disabled !== true).id;
                    }
                } else {
                    $scope.packageId =_.find(packages, p => p.disabled !== true).id;
                }

                if ($scope.withRehabilitation) {
                    $scope.setRehabilitationValues();
                }
                $scope.choosePackage();
            }
        });
    };
    // @TODO </HEALTH2019>

    if ($scope.data.user) {
        $scope.userData = $scope.data.user;

        $scope.ref.selectedItemBranch = $scope.data.user.person.branch;

        $scope.data.person = $scope.userData.person;
        delete $scope.data.person.creationTime;

        $scope.data.userId = $scope.data.user.id;

        if ($scope.userData.person.address) {
            $scope.data.person.address = $scope.userData.person.address;
            delete $scope.data.person.address.creationTime;
        }
    } else {
        $scope.data.person = {};
        $scope.data.person.address = {};

        $scope.data.userId = '';
    }

    $scope.acceptStatement = [];
    for (var a = 0; a < 1; a++) {
        $scope.acceptStatement[a] = false;
    }

    if ($scope.stateParams.branch) {
        $scope.data.branch = $scope.stateParams.branch.name;
    }

    addStatementsTo($scope.data.person);

    $scope.data.partner = {};
    $scope.data.children = [];
    $scope.data.seniors = [];

    $scope.seniorLimit = 2;
    $scope.senors_length = 0;

    $scope.accept = function () {
        $scope.form.$setSubmitted();
        $scope.register($scope.form);
    };

    $scope.register = function (form) {
        if (!form.$valid) {
            return 0;
        }

        var $data = angular.copy($scope.data);

        var childrenLength = Object.keys($data.children).length;
        var partnerLength = ($data.partner && Object.keys($data.partner).length) ? 1 : 0;

        if ($scope.package.partner && !$scope.package.children) {
            if (childrenLength + partnerLength < 1) {
                popUpService.showPopUpBigInfo('', 'Dodaj partnera', 'Aby zatwierdzić deklarację musisz dodać partnera lub dziecko.');
                return 0;
            }
        } else if ($scope.package.partner && $scope.package.children) {
            if (childrenLength + partnerLength < 2) {
                popUpService.showPopUpBigInfo('', 'Dodaj osoby', 'Aby zatwierdzić deklarację musisz dodać co najmniej 2 osoby.');
                return 0;
            }
        }

        // Age validation
        $data.person.citizenshipType = $scope.nationality;
        // Employee
        if ($data.person.citizenshipType === 'POLISH') {
            if (!$filter('isOver16FromIdentifier')($data.person.identifier)) {
                popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz przystąpić mając poniżej 16 lat.', '');
                return 0;
            }
        } else {
            if (!$filter('isOver16FromBirthdate')($data.person.birthdate)) {
                popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz przystąpić mając poniżej 16 lat.', '');
                return 0;
            }
        }

        // Partner
        if (partnerLength) {
            if ($data.partner.nationality === 'POLISH') {
                if (!$filter('isOver16FromIdentifier')($data.partner.identifier)) {
                    popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz dodać partnera, który nie ukończył 16 lat', '');
                    return 0;
                }
                if ($filter('isOver69FromIdentifier')($data.partner.identifier)) {
                    popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz dodać partnera, który ma powyżej 69 lat', '');
                    return 0;
                }
            } else {
                if (!$filter('isOver16FromBirthdate')($data.partner.birthdate)) {
                    popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz dodać partnera, który nie ukończył 16 lat', '');
                    return 0;
                }
                if ($filter('isOver69FromBirthdate')($data.partner.birthdate)) {
                    popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz dodać partnera, który ma powyżej 69 lat.', '');
                    return 0;
                }
            }
        }

        // Children
        if (childrenLength) {
            for (let a = 0; a < childrenLength; a++) {
                if ($data.children[a].member === 'CHILD') {
                    if ($data.children[a].nationality === 'POLISH') {
                        if ($filter('isOver25FromIdentifier')($data.children[a].identifier)) {
                            popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz dodać dziecka, który ma powyżej 25 lat.', '');
                            return 0;
                        }
                    } else {
                        if ($filter('isOver25FromBirthdate')($data.children[a].birthdate)) {
                            popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz dodać dziecka, który ma powyżej 25 lat.', '');
                            return 0;
                        }
                    }
                }
            }
        }

        // Seniors
        if ($data.seniors) {
            for (let i = 0; i < $data.seniors.length; i++) {
                if ($data.seniors[i].nationality === 'POLISH') {
                    if (!$filter('isOver16FromIdentifier')($data.seniors[i].identifier)) {
                        popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz dodać seniora, który nie ukończył 16 lat', '');
                        return 0;
                    }
                    if ($filter('isOver80FromIdentifier')($data.seniors[i].identifier)) {
                        popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz dodać seniora, który ma powyżej 80 lat.', '');
                        return 0;
                    }
                } else {
                    if (!$filter('isOver16FromBirthdate')($data.seniors[i].birthdate)) {
                        popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz dodać seniora, który nie ukończył 16 lat', '');
                        return 0;
                    }
                    if ($filter('isOver80FromBirthdate')($data.seniors[i].birthdate)) {
                        popUpService.showPopUpBigInfo('', 'Błędne dane', 'Nie możesz dodać seniora, który ma powyżej 80 lat.', '');
                        return 0;
                    }
                }
            }
        }

        if ($data.partner && Object.keys($data.partner).length) {
            fillMissingDataForInsured($data.partner);
        } else {
            delete $data.partner;
        }

        if ($data.children && Object.keys($data.children).length) {
            for (let i = 0; i < Object.keys($data.children).length; i++) {
                fillMissingDataForInsured($data.children[i]);
            }
        }

        if ($data.seniors && Object.keys($data.seniors).length) {
            for (let i = 0; i < Object.keys($data.seniors).length; i++) {
                fillMissingDataForInsured($data.seniors[i]);
            }
        }

        $data.person.citizenshipType = $scope.nationality;
        $data.person.identifierType = ($scope.nationality !== 'POLISH') ? 'OTHER' : 'PESEL';
        $data.person.identifier = ($scope.nationality !== 'POLISH') ? $data.person.id : $data.person.identifier;
        $data.person.gender = ($data.person.nationality === 'POLISH') ? $filter('getSexFromIdentifier')($data.person.identifier) : $data.person.gender;
        $data.proposedDate = $scope.proposedDate;
        $data.person.acceptsMarketingElectronicMessages = $data.person.statements[0].checked;
        delete $data.person.statements;

        var branchId;
        if (typeof $scope.ref.selectedItemBranch.id === 'undefined') {
            if (typeof $data.user.person.branchId !== 'undefined') {
                branchId = $data.user.person.branchId;
            }
        } else {
            branchId = $scope.ref.selectedItemBranch.id;
        }

        $data.branch = {id: branchId};

        if ($scope.withRehabilitation) {
            $data.rehabilitation = true;
        }

        zochaPzuwHealthInsuranceService.addDeclaration($data).then(function (data) {
            if (data.status === 200) {
                $scope.showPopUp('Gratulacje!', 'Deklaracja została zgłoszona.', 'Przejdź do listy deklaracji', 'root.home.zoch.healthPzuw.list({"user": null})', {
                    text: 'Dodaj kolejną deklarację',
                    reload: true,
                });
            } else {
                if (data.data.message === 'DuplicateIdentifierException') {
                    popUpService.showPopUpWithError(data.data, {
                        head: 'Użycie zajętego PESEL/Numer paszportu',
                        content: 'Użytkownik o wskazanym numerze PESEL/Numer paszportu istnieje w systemie. Skontaktuj się z Administratorem.'
                    });
                } else if (data.data.message === 'DuplicateHRNumberException') {
                    popUpService.showPopUpWithError(data.data, {
                        head: 'Rejestracja nieudana',
                        content: 'Użytkownik o wskazanym numerze kadrowym istnieje w systemie. Skontaktuj się z Administratorem.'
                    });
                } else if (data.data.message === 'DuplicateEmailException') {
                    popUpService.showPopUpWithError(data.data, {
                        head: 'Rejestracja nieudana',
                        content: 'Użytkownik o wskazanym adresie e-mail istnieje w systemie. Skontaktuj się z Administratorem.'
                    });
                } else {
                    popUpService.showPopUpWithError(data.data, {
                        head: 'Rejestracja nieudana',
                        content: 'Niestety nie udało się zarejestrować konta. Skontaktuj się z administratorem.'
                    });
                }
            }
        });
    };

    function fillMissingDataForInsured(insured) {
        insured.identifierType = (insured.nationality !== 'POLISH') ? 'OTHER' : 'PESEL';
        insured.identifier = (insured.nationality !== 'POLISH') ? insured.id : insured.identifier;
        insured.birthdate = (insured.nationality !== 'POLISH') ? $filter('getDateFromBirthdate')(insured.birthdate) : $filter('getDateFromIdentifier')(insured.identifier);
        insured.citizenshipType = insured.nationality;
        insured.gender = (insured.nationality === 'POLISH') ? $filter('getSexFromIdentifier')(insured.identifier) : insured.gender;
        insured.acceptsMarketingElectronicMessages = insured.statements[0].checked;

        delete insured.statements;
        delete insured.nationality;
        delete insured.id;
        delete insured.sameAddress;
    }


    $scope.showPopUp = function (head, content, text, target, secondButton) {
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'locals', function ($scope, $mdDialog, locals) {
                $scope.locals = locals;

                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.cancel = function () {
                    $mdDialog.cancel();
                };

                $scope.confirm = function (payload) {
                    $mdDialog.hide(payload);
                };
            }],
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            clickOutsideToClose: false,
            locals: {
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                },
                secondButton: secondButton
            }
        }).then(function (data) {
            if (data && data.reload) {
                $state.reload();
            }
        }, function () {

        });
    };

    $scope.addFamilyMember = function (type) {
        if (type === 'PARTNER') {
            $scope.data.partner = {
                birthdate: new Date('01/01/2000'),
                nationality: 'POLISH',
                address: $scope.data.person.address,
                sameAddress: true
            };

            $scope.partner_length = 1;
            $scope.partner_block = true;

            if (!$scope.package.children) {
                $scope.children_block = true;
            }
            addStatementsTo($scope.data.partner);
        }

        if (type === 'CHILD') {
            let child = {
                birthdate: new Date('01/01/2000'),
                nationality: 'POLISH',
                member: 'CHILD',
                address: $scope.data.person.address,
                sameAddress: true
            };
            addStatementsTo(child);
            $scope.data.children.push(child);

            $scope.children_length = Object.keys($scope.data.children).length;

            if (!$scope.package.children) {
                $scope.partner_block = true;
                $scope.children_block = true;
            } else {
                if ($scope.children_length >= $scope.package.children) {
                    $scope.children_block = true;
                }
            }
        }
        if (type === 'SENIOR') {
            let senior = {
                nationality: 'POLISH',
                member: 'SENIOR',
                address: angular.copy($scope.data.person.address),
                sameAddress: true
            };
            addStatementsTo(senior);
            $scope.data.seniors.push(senior);

            $scope.pricePackage += $scope.package.seniorPrice;

            $scope.seniors_length = Object.keys($scope.data.seniors).length;

        }
    };

    $scope.deleteFamilyMember = function (type, obj) {
        if (type === 'PARTNER') {
            $scope.data.partner = {};
            $scope.partner_length = 0;

            if (!$scope.package.children) {
                $scope.partner_block = false;
                $scope.children_block = false;
            } else {
                $scope.partner_block = false;
            }
        } else if (type === 'CHILD') {
            $scope.data.children.splice(obj, 1);
            $scope.children_length = Object.keys($scope.data.children).length;

            if (!$scope.package.children) {
                $scope.partner_block = false;
                $scope.children_block = false;
            } else {
                $scope.children_block = false;
            }
        } else if (type === 'SENIOR') {
            $scope.data.seniors.splice(obj, 1);
        }
    };

    $scope.$watch('data.person.address', function (oldVal, newVal) {
        if (oldVal !== newVal) {
            if ($scope.data.partner) {
                if ($scope.data.partner.sameAddress) {
                    $scope.data.partner.address = angular.copy($scope.data.person.address);
                }
            }

            if ($scope.data.children && $scope.data.children.length) {
                for (var a = 0; a < $scope.data.children.length; a++) {
                    if ($scope.data.children[a].sameAddress) {
                        $scope.data.children[a].address = angular.copy($scope.data.person.address);
                    }
                }
            }
        }
    }, true);

    var collection = ['data.partner.sameAddress',
        'data.children[0].sameAddress', 'data.children[1].sameAddress', 'data.children[2].sameAddress', 'data.children[3].sameAddress', 'data.children[4].sameAddress', 'data.children[5].sameAddress', 'data.children[6].sameAddress', 'data.children[7].sameAddress',
        'data.seniors[0].sameAddress', 'data.seniors[1].sameAddress', 'data.seniors[2].sameAddress', 'data.seniors[3].sameAddress'
    ];
    $scope.$watchGroup(collection, function (oldVal, newVal) {
        if (oldVal !== newVal) {
            if ($scope.data.partner) {
                if ($scope.data.partner.sameAddress) {
                    $scope.data.partner.address = angular.copy($scope.data.person.address);
                } else {
                    // $scope.data.partner.address = {};
                }
            }

            if ($scope.data.children && $scope.data.children.length) {
                for (var a = 0; a < $scope.data.children.length; a++) {
                    if ($scope.data.children[a].sameAddress) {
                        $scope.data.children[a].address = angular.copy($scope.data.person.address);
                    } else {
                        // $scope.data.children[a].address = {};
                    }
                }
            }
        }
    });

    $scope.notExistEmail = false;
    $scope.$watch('notExistEmail', function (oldVal, newVal) {
        if (oldVal !== newVal) {
            if ($scope.notExistEmail) {
                $scope.data.person.email = '';
            }
        }
    });

    zochaPzuwHealthInsuranceService.getBranchesForDeclaration().then(function (data) {
        $scope.branch = data.data.data;
        if (!$rootScope.CONFIGURATOR.zoch.healthInsurance.isBranchEnabled) {
            $scope.ref.selectedItemBranch = $scope.branch[0];
        }
    });

    // ##### FILTER ##### //
    $scope.ref.querySearchBranch = function (query) {
        var results = query ? $scope.branch.filter(createFilterForItem(query)) : $scope.branch;
        return results;
    };

    function createFilterForItem(query) {
        var lowercaseQuery = query.toLowerCase();

        return function filterFn(items) {
            return (items.name.toLowerCase().indexOf(lowercaseQuery) !== -1);
        };
    }

    let date = new Date();
    let dayOfMonth = date.getDate();
    let requiredDayOfMonth = $rootScope.CONFIGURATOR.healthInsurancePzuw.employerSaveDeclarationDayLimit;

    if ($rootScope.CONFIGURATOR.healthInsurancePzuw.employerSaveDeclarationDayLimitException) {
        let exceptionDate = moment($rootScope.CONFIGURATOR.healthInsurancePzuw.employerSaveDeclarationDayLimitException);
        if (date.getFullYear() === exceptionDate.year() && date.getMonth() === exceptionDate.month()) {
            requiredDayOfMonth = exceptionDate.day();
        }
    }

    if (dayOfMonth < requiredDayOfMonth || (dayOfMonth === requiredDayOfMonth && date.getHours() < 12)) {
        // to najbliższy
        date = new Date(date.getFullYear(), date.getMonth() + 1);
    } else {
        // to +1 miesiąc
        date = new Date(date.getFullYear(), date.getMonth() + 2);

    }
    $scope.proposedDate = moment(date).format('YYYY-MM-DD');

    /**
     * Method findByIdentifier busy indicator;
     * If it's true, method won't be executed;
     * @type {boolean}
     */
    $scope.findPending = false;
    /**
     * Fetches user by identifier (pesel);
     * @param form
     */
    $scope.findByIdentifier = function (form) {
        if (form.$invalid) {
            return;
        }
        if ($scope.findPending) {
            return;
        }
        $scope.findPending = true;

        zochaWorkersService.findByIdentifier($scope.pesel)
            .then(function (success) {
                if (!success.data.data.length) {
                    $scope.data.person.identifier = $scope.pesel;
                    return;
                }
                var userData = success.data.data[0];
                var userPersonData = userData.person;
                userPersonData.address.zipCode = userPersonData.address.zipCode ? userPersonData.address.zipCode.replace(/-/g, '') : '';

                /**
                 * Although this if/else is not necessary here, because it is possible to fetch user by pesel only (polish citizens only);
                 */
                if (userPersonData.identifierType === 'PESEL' || userPersonData.citizenshipType === 'POLISH' || userPersonData.identifierType === null) {
                    $scope.nationality = 'POLISH';
                } else {
                    $scope.nationality = 'OTHER';
                }

                $scope.notExistEmail = !angular.isDefined(userPersonData.email) || !userPersonData.email;

                if (userPersonData.branchId) {
                    $scope.ref.selectedItemBranch = {name: userPersonData.branch, id: userPersonData.branchId};
                    $scope.data.branch = {id: userPersonData.branchId, name: userPersonData.branch};
                }

                $scope.data.userId = userData.userId;
                $scope.data.person = userPersonData;
                addStatementsTo($scope.data.person);

                if ($rootScope.CONFIGURATOR.healthInsurancePzuw.anniversaryChangesMonth !== (new Date().getMonth() + 1)) {
                    zochaPzuwHealthInsuranceService.getUsersLastActiveDeclaration($scope.data.userId)
                        .then(function (declaration) {
                            let lastActiveDeclarationWeight = declaration.benefit.weight;
                            let firstVariant = null;
                            let firstPackage = null;
                            for (let i = 0; i < $scope.variants.length; i++) {
                                $scope.variants[i].disabled = true;
                                for (let j = 0; j < $scope.variants[i].options.length; j++) {
                                    if ($scope.variants[i].options[j].weight < lastActiveDeclarationWeight) {
                                        $scope.variants[i].options[j].disabled = true;
                                    } else {
                                        $scope.variants[i].disabled = false;
                                        $scope.variants[i].options[j].disabled = false;
                                        if (firstVariant == null) {
                                            firstVariant = $scope.variants[i];
                                        }
                                        if (firstPackage == null) {
                                            firstPackage = $scope.variants[i].options[j];
                                        }
                                    }
                                }
                            }
                            $scope.variantId = firstVariant.name;
                            $scope.chooseVariant();
                            $scope.packageId = firstPackage.id;
                            $scope.choosePackage();
                        });
                }
            })
            .finally(function () {
                $scope.findPending = false;
            });
    };

    function addStatementsTo(person) {
        if (!person) {
            return;
        }
        person.statements = [
            {
                text: '1. Wyrażam zgodę na wysłanie maila powitalnego wraz z informacją o możliwości założenia konta w portalu moje.pzu.pl na wskazany wyżej numer telefonu i adres e-mail.',
                checked: false
            },
        ];
    }
}]);
